import { render, staticRenderFns } from "./approveTicketAffiliate.vue?vue&type=template&id=5ecaddcb&lang=pug"
import script from "./approveTicketAffiliate.vue?vue&type=script&lang=js"
export * from "./approveTicketAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports